import React from 'react';
import {Box, Typography} from '@mui/material';
import {useTranslate} from 'react-admin';
import {t} from '../themes/statamicTokens';
import StatusPill from './statamic/StatusPill';
import EmptyState from './statamic/EmptyState';

const TranslationTable = ({translations}) => {
    const translate = useTranslate();

    if (!translations || translations.length === 0) {
        return (
            <EmptyState
                title={translate('No translations yet')}
                description={translate('Translations will appear here after the content is published in multiple languages.')}
                dense
            />
        );
    }

    return (
        <Box
            sx={{
                border: `1px solid ${t.color.border.default}`,
                borderRadius: `${t.radius.md}px`,
                overflow: 'hidden',
                backgroundColor: t.color.surface,
            }}
        >
            <Box component="table" sx={{width: '100%', borderCollapse: 'collapse'}}>
                <Box component="thead">
                    <Box component="tr" sx={{backgroundColor: t.color.surface}}>
                        {[translate('Language'), translate('Translation'), translate('Original')].map(label => (
                            <Box
                                key={label}
                                component="th"
                                sx={{
                                    textAlign: 'left',
                                    px: 2,
                                    py: 1,
                                    fontSize: `${t.type.caption.size}px`,
                                    fontWeight: 600,
                                    color: t.color.text.secondary,
                                    borderBottom: `1px solid ${t.color.border.default}`,
                                }}
                            >
                                {label}
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Box component="tbody">
                    {translations.map((tr, i) => (
                        <Box
                            component="tr"
                            key={tr.language_code ?? tr.languageCode ?? tr.id}
                            sx={{
                                '& > td': {
                                    borderBottom: i === translations.length - 1 ? 'none' : `1px solid ${t.color.border.hairline}`,
                                },
                            }}
                        >
                            <Box component="td" sx={{px: 2, py: 1.25, verticalAlign: 'top'}}>
                                <StatusPill variant="neutral">
                                    {String(tr.language_code ?? tr.languageCode ?? '').toUpperCase()}
                                </StatusPill>
                            </Box>
                            <Box component="td" sx={{px: 2, py: 1.25, verticalAlign: 'top'}}>
                                <Typography sx={{fontSize: `${t.type.body.size}px`, color: t.color.text.primary}}>
                                    {tr.translation || <Box component="span" sx={{color: t.color.text.muted}}>—</Box>}
                                </Typography>
                            </Box>
                            <Box component="td" sx={{px: 2, py: 1.25, verticalAlign: 'top', width: 110}}>
                                {tr.original ? (
                                    <StatusPill variant="success">{translate('Original')}</StatusPill>
                                ) : (
                                    <Box component="span" sx={{color: t.color.text.muted, fontSize: `${t.type.caption.size}px`}}>—</Box>
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default TranslationTable;
